import { FC, ReactNode, useCallback } from 'react'
import cn from 'classnames'

import { ReactComponent as Question } from '@src/assets/question.svg'
import style from '@src/components/SubscribeBlock/SubscribeBlock.module.scss'
import { Button } from '@src/components/Button/Button'
import { NavLink } from 'react-router-dom'
import { parsPrice } from '@src/lib/utils'

type SubscribeBlockProps = {
  title: string | ReactNode
  cost?: number | string
  btn?: boolean
  className?: string
  btnName?: string
  btnDisabled?: boolean
  btnType?: 'primary' | 'secondary' | 'text' | 'textSecondary'
  btnClick?: (e:any) => void
  btnOutline?: boolean
  btnLoading?: boolean
  path?: number
  descriptionTariff?: string
}

export const SubscribeBlock: FC<SubscribeBlockProps> = ({
  descriptionTariff,
  path,
  btn,
  title,
  cost,
  className,
  btnName,
  btnClick,
  btnDisabled,
  btnType = 'primary',
  btnOutline,
  btnLoading,
}) => {
  const handleBtn = useCallback((e) => {
    e.preventDefault()
    if (btnClick) btnClick(e)
  }, [btnClick])

  return (
    <>
      <NavLink
        to={path ? `/tariff/${path}` : '#'}
        onClick={(e) => !path && e.preventDefault()}
        className={cn(style.block, className)}
      >
        <div className={style.left}>
          {descriptionTariff && (
          <div className={style.svgBlock}>
            <Question />
            <div className={style.message}>
              {/* <p className={style.message_title}>Docsis 3.0 Technicolor 7200</p> */}
              <p>
                {descriptionTariff}

              </p>
            </div>
          </div>
          )}
          <div>
            <div className={style.title}>{title}</div>
          </div>
        </div>
        <div className={style.right}>
          {typeof cost === 'number' ? (
            <div className={style.cost}>
              Стоимость
              <span>{parsPrice(cost)}</span>
              {' '}
              р/мес
            </div>
          ) : (
            <div className={style.cost}>
              <span>{cost}</span>
            </div>
          )}
          {btn && (
          <Button
            type={btnType}
            disabled={btnDisabled || btnLoading}
            className={style.buttonSub}
            onClickFunc={handleBtn}
            outline={btnOutline}
            // loading={btnLoading}
          >
            {btnName}
          </Button>
          )}
        </div>
      </NavLink>
    </>
  )
}
